import { render, staticRenderFns } from "./CopyNovelDialog.vue?vue&type=template&id=173e6b22&scoped=true"
import script from "./CopyNovelDialog.vue?vue&type=script&lang=ts"
export * from "./CopyNovelDialog.vue?vue&type=script&lang=ts"
import style0 from "./CopyNovelDialog.vue?vue&type=style&index=0&id=173e6b22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173e6b22",
  null
  
)

export default component.exports